import axios from 'axios';
import Cookies from "../components/cookies";
import config from "../config";

const cookie = new Cookies();

axios.defaults.baseURL = config.servers["base"];


function getAuthHeaders() {
    const token = cookie.getCookie("access_token"); // always fresh
    return {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };
}

axios.defaults.baseURL = config.servers["base"];

export async function fetchUsers(params = {}) {
    const urlToLoad = `user/read/`;

    try {
        const response = await axios.post(
            urlToLoad,
            params,
            {
                headers: getAuthHeaders(),
                withCredentials: true, // optional, safe to keep true
            }
        );
        console.log("Fetch users response:", response.data);
        return response.data.message;
    } catch (error) {
        console.error("Read users failed:", error);
        throw error.response?.data || { message: "Read users failed" };
    }
}

export async function addUser(params = {}) {
    const urlToLoad = `user/add/`;
    try {
        const response = await axios.post(
            urlToLoad,
            params,
            {
                headers: getAuthHeaders(),
                withCredentials: true, // optional, safe to keep true
            }
        );
        console.log("Fetch users response:", response.data);
        return response.data.message;
    } catch (error) {
        console.error("Read users failed:", error);
        throw error.response?.data || { message: "Read users failed" };
    }
}

export async function updateUser(userData) {
    try {
        const response = await axios.post(`/user/update/`, {
            params: userData,
        });
        return response.data;
    } catch (err) {
        console.error("Error updating user:", err);
        throw err;
    }
}

export async function deleteUser(userId) {
    const urlToLoad = `user/delete/`;
    try {
        const response = await axios.post(
            urlToLoad,
            { email: userId },
            {
                headers: getAuthHeaders(),
                withCredentials: true, // optional, safe to keep true
            }
        );
        console.log("Fetch users response:", response.data);
        return response.data.message;
    } catch (error) {
        console.error("Read users failed:", error);
        throw error.response?.data || { message: "Read users failed" };
    }
}
